import { Component } from '@verndale/core';
import MicroModal from 'micromodal';

import { constEvent } from '../utils/constants';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el
    };
    this.modalId = null;

    this.init();
  }

  addListeners() {
    document._on(
      constEvent.SHOW_MODAL_CHANGE_ADDRESS,
      this.showModal.bind(this)
    );

    document._on(
      constEvent.CLOSE_MODAL_CHANGE_ADDRESS,
      this.closeModal.bind(this)
    );

    document._on(
      constEvent.UPDATED_DELIVERY_ADDRESS,
      this.onUpdatedDeliveryAddrees.bind(this)
    );
  } //addListeners

  init() {
    const { $el } = this.dom;

    const $genericModal = $el.closest('.generic-modal');
    if ($genericModal) {
      this.modalId = $genericModal.getAttribute('id') || null;
    }
  } //init

  showModal(e) {
    e.preventDefault();

    if (this.modalId) {
      MicroModal.show(this.modalId, {
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true
      });
    }
  } //showModal

  onUpdatedDeliveryAddrees() {
    location.reload();
  } //onUpdatedDeliveryAddrees

  closeModal(e) {
    e.preventDefault();

    if (this.modalId) {
      MicroModal.close(this.modalId);
    }
  } //closeModal
}

export default Module;
